/**
 * 线下培训班级学员列表功能
 * @Author:wuTao
 * @Date 2020/3/6
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './config';

import {component_tool, framework_tool, utils_tool} from '@/tool'

let {checkStrLength,Session} = utils_tool;
let { WizSpin, WizBrowserExport,WizTabs} = component_tool;
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
import { WizCard } from 'wiz-components/lib';
import ExamInfo  from '../../examInfo';
let { TabPane } = WizTabs

class ErrorQuestionPersonInfoList extends WizContainer {

  componentName = 'errorQuestionPersonInfoList';

  constructor(props) {
    super(props);
    const {history} = props;
    this.state = {
      
    };
    this.initialValue = {};
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location.record) {
      Session.set('examQuestionInfo', history.location.record);
      this.initialValue = history.location.record;
    } else if (Session.get('examQuestionInfo')) {
      this.initialValue = Session.get('examQuestionInfo') ? Session.get('examQuestionInfo') : {};
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfo',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '答错次数',
        field: 'count',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      WizBrowserExport({
        title: '错误人员情况',
        sheetName: '错误人员情况',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '错误人员情况.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const {examRecordLoading} = this.props;
    let initialValue = this.initialValue;
    const {questionId,personIds,examId,examName,examDate,answer} = initialValue;
    let _templateConfig = templateConfig({
      examId: examId, 
      personIds
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      examId: examId,
      personIds : personIds,
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      },
    });

   
   
    let record = {examName,examDate,questionId,answer}
    
    return <>
        <ExamInfo record={record} />
        <WizCard title={'错误人员情况'}>
          <WizReduxTemplate {..._reduxTemplateConfig} />
        </WizCard>

      </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examRecord } = state;
  const load = modelUtils.getLoadingState(state, ['examRecord']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ErrorQuestionPersonInfoList);
